import { useHeatReportContext } from "@/pages/heat-report/context/HeatReportContext";
import {
  BorderedTablePaper,
  OutlinedTextarea,
  LeftGroupedTextField,
  RightGroupedTextField,
} from "@/pages/heat-report/styles/HeatReportStyledComponents";
import { getMomentTz } from "@dexteel/mesf-core";
import { Box, Grid, TextField, Typography } from "@mui/material";
import { AssetCard } from "../../../controls/AssetCard";
import { DurationFieldDE } from "@/shared/data-entries/common/DurationFieldDE";
import { CheckboxFieldDE } from "@/shared/data-entries/common/CheckboxFieldDE";

const moment = getMomentTz();
export const HeaderData = () => {
  const {
    state: { casProcessData, torchesProcessData },
  } = useHeatReportContext();

  return (
    <BorderedTablePaper elevation={0}>
      <Box padding={1}>
        <Grid item xs={12} container spacing={2} key={casProcessData.ProcessId}>
          {/* Column 1 */}
          <Grid
            item
            xs={12}
            sm={6}
            md={2}
            container
            key={`${casProcessData.ProcessId}-column-1`}
          >
            <Grid item xs={12} key={`${casProcessData.ProcessId}-asset`}>
              <AssetCard
                assetId={casProcessData.AssetId || 13}
                assetName={casProcessData.AssetName || "Caster"}
              />
            </Grid>
          </Grid>

          {/* Column 2 */}
          <Grid
            item
            xs={12}
            sm={6}
            md={2}
            container
            key={`${casProcessData.ProcessId}-column-2`}
          >
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid
                  item
                  xs={6}
                  key={`${casProcessData.ProcessId}-arrive-time`}
                >
                  <TextField
                    label="Arrive"
                    value={
                      casProcessData?.Start
                        ? moment(casProcessData.Start).format(
                            "HH:mm - MM/DD/YYYY",
                          )
                        : " "
                    }
                    variant="outlined"
                    fullWidth
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6} key={`${casProcessData.ProcessId}-end-time`}>
                  <TextField
                    label="End"
                    value={
                      casProcessData?.End
                        ? moment(casProcessData.End).format(
                            "HH:mm - MM/DD/YYYY",
                          )
                        : " "
                    }
                    variant="outlined"
                    fullWidth
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  key={`${casProcessData.ProcessId}-ladle-open-time`}
                >
                  <TextField
                    label="Ladle Open"
                    value={
                      casProcessData?.LadleOpen
                        ? moment(casProcessData.LadleOpen).format(
                            "HH:mm - MM/DD/YYYY",
                          )
                        : " "
                    }
                    variant="outlined"
                    fullWidth
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  key={`${casProcessData.ProcessId}-ladle-close-time`}
                >
                  <TextField
                    label="Ladle Close"
                    value={
                      casProcessData?.LadleClose
                        ? moment(casProcessData.LadleClose).format(
                            "HH:mm - MM/DD/YYYY",
                          )
                        : ""
                    }
                    variant="outlined"
                    fullWidth
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  key={`${casProcessData.ProcessId}-foreman-caster`}
                >
                  <TextField
                    label="Caster Foreman"
                    value={casProcessData?.Foreman ?? ""}
                    variant="outlined"
                    fullWidth
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  key={`${casProcessData.ProcessId}-operator-caster`}
                >
                  <TextField
                    label="Caster Operator"
                    value={casProcessData?.Operator ?? ""}
                    variant="outlined"
                    fullWidth
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Column 3 */}
          <Grid
            item
            xs={12}
            sm={6}
            md={2}
            container
            key={`${casProcessData.ProcessId}-column-3`}
          >
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <LeftGroupedTextField
                    label="Tundish"
                    variant="outlined"
                    fullWidth
                    value={casProcessData?.TundishName || ""}
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <RightGroupedTextField
                    label="Heats On Tundish"
                    variant="outlined"
                    fullWidth
                    value={casProcessData?.HeatsOnTundish || ""}
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <LeftGroupedTextField
                    label="Shroud"
                    variant="outlined"
                    fullWidth
                    value={casProcessData?.TundishShroudName || ""}
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <RightGroupedTextField
                    label="Heats On Shroud"
                    variant="outlined"
                    fullWidth
                    value={casProcessData?.HeatsOnTundishShroud || ""}
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  key={`${casProcessData.ProcessId}-foreman-torches`}
                >
                  <TextField
                    label="Torches Foreman"
                    value={torchesProcessData?.Foreman ?? ""}
                    variant="outlined"
                    fullWidth
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  key={`${casProcessData.ProcessId}-operator-torches`}
                >
                  <TextField
                    label="Torches Operator"
                    value={torchesProcessData?.Operator ?? ""}
                    variant="outlined"
                    fullWidth
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* Column 4 */}
          <Grid
            item
            xs={12}
            sm={6}
            md={2}
            container
            key={`${casProcessData.ProcessId}-column-4`}
          >
            <Grid item xs={12}>
              <Grid container spacing={1}>
                <Grid
                  item
                  xs={6}
                  key={`${casProcessData.ProcessId}-pourback-weight`}
                >
                  <TextField
                    label="Pourback"
                    value={casProcessData?.PourbackWeight?.toFixed(1) ?? ""}
                    variant="outlined"
                    fullWidth
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6} key={`${casProcessData.ProcessId}-cast-tons`}>
                  <TextField
                    label="Cast Tons"
                    value={casProcessData?.CastTons?.toFixed(1) ?? ""}
                    variant="outlined"
                    fullWidth
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={6} key={`${casProcessData.ProcessId}-scrap-lbs`}>
                  <TextField
                    fullWidth
                    variant={"outlined"}
                    label={"Scrap Weight [lbs]"}
                    value={casProcessData?.ScrapTons ?? ""}
                    slotProps={{
                      input: {
                        readOnly: true,
                      },
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  key={`${casProcessData.ProcessId}-duration-time`}
                >
                  <DurationFieldDE
                    label={"Cast Time [hh:mm:ss]"}
                    value={
                      casProcessData?.Duration
                        ? Number(casProcessData?.Duration)
                        : null
                    }
                    unit={"seconds"}
                    onChange={() => {}}
                  />
                </Grid>
                <Grid item xs={6}>
                  <CheckboxFieldDE
                    label="Manual Opened"
                    value={!!casProcessData?.IsManualOpen}
                    disabled
                  />
                </Grid>
                <Grid item xs={6}>
                  <CheckboxFieldDE
                    label="Ladle Shrouded"
                    value={!!casProcessData?.IsLadleShrouded}
                    disabled
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid
            item
            xs={6}
            sm={6}
            md={2}
            container
            key={`${casProcessData.ProcessId}-column-5`}
          >
            <Grid item md={12}>
              <Typography variant="subtitle2" gutterBottom>
                Torches Comments
              </Typography>
              <OutlinedTextarea
                placeholder="Notes"
                rows={5}
                value={torchesProcessData?.TorchesComments ?? ""}
                disabled
              />
            </Grid>
          </Grid>

          {/* Column 6 */}
          <Grid
            item
            xs={6}
            sm={6}
            md={2}
            container
            key={`${casProcessData.ProcessId}-column-6`}
          >
            <Grid item md={12}>
              <Typography variant="subtitle2" gutterBottom>
                Caster Comments
              </Typography>
              <OutlinedTextarea
                placeholder="Notes"
                rows={5}
                value={casProcessData?.Comments ?? ""}
                disabled
              />
            </Grid>
          </Grid>
        </Grid>
      </Box>
    </BorderedTablePaper>
  );
};
